export class UploadFile3Information {
    applicationType: string;
    applicationID: number;
    damsApplicationID: string;
    applicationLocation: string;
    sraFiles:SRAUpload[] | string[];
  
    setData(applicationType: string, damsApplicationID: string, applicationLocation: string,
            files:  SRAUpload[] ): void {
      this.applicationType = applicationType;
      this.damsApplicationID = damsApplicationID;
      this.applicationLocation = applicationLocation;
      this.sraFiles = files;
    }
  
   
  }
  class SRAUpload{  
    name:string
    attachmentType:string
  }
  


// WEBPACK FOOTER //
// ./src/app/shared/data-objects/upload-file3-information.ts